export const PPPaddons = [
  /*'Phone Protection Plan 9 $9.00',
  'Phone Protection Plan $9.00',
  'Phone Protection Plan $11.00',
  'Phone Protection Plan Plus $15.00',
  'Phone Protection Plan $14.00',
  'Phone Protection Plan $18.00',*/
   "Phone Protection Plan $11.00",
   "Phone Protection Plan Plus $15.00",
  
];

export const AppleCareAddons = [
  'Phone Protection Plan Plus featuring AppleCare Services $18.00',
  'Phone Protection Plan featuring AppleCare Services $14.00',
];

export const addonList = [
  ...PPPaddons,
  ...AppleCareAddons,
  'Voicemail+ $5.00',
  'Visual Voicemail $4.00',
  'World Traveller $8.00',
  'Unlimited Long Distance - USA $5.00',
  'Big Gig World Saver - Freedom Nationwide $5.00',
  '1GB Freedom Nationwide Add-On(FS) $15.00',
  '2GB Freedom Nationwide Add-On(FS) $30.00',
  '3GB Freedom Nationwide Add-On(FS) $45.00',
  'ILD - India(250 minutes) $10.00',
  'ILD - India(250 minutes)',
  'ILD - India(1000 Minutes) $15.00',
  'ILD - India(1000 Minutes)',
  'ILD - China or Hong Kong (250 minutes) $10.00',
  'ILD - China or Hong Kong (1000 minutes) $15.00',
  '1500 ILD Minutes at $5 per mo. to 6 Destinations $5.00',
];

export const oldAddonList =["Unlimited U.S Talk + Text + 40GB Data for U.S Plans $0.00 / month"]

export const storeNameList = {
  OSHWTIN: 'Lake Vista Plaza',
  LAKESIN: 'Lakeshore & Islington',
  VYAD2IN: 'Center Mall Barton',
  TCPNFIN: 'Town Center Plaza',
  VYACBIN: 'Cedarbrae Mall',
  BARRIIN: 'Barrie',
  VYAREIN: 'Rexdale & Islington',
  DTWICIN: 'Briarfield Shopping Centre',
  DAN01IN: 'Danforth & Woodbine',
  VYOSHIN: 'Big Bay',
  VYAMLIN: 'Markham & Lawrence',
  VYAWLIN: 'Weston & Lawrence',
  DUNBLIN: 'Oriental Centre',
  AllStores: 'All Stores',
};

export const channelCode = {
  VYAREIN: 'WD184401',
  VYAD2IN: 'WD184405',
  VYAMLIN: 'WD184408',
  DAN01IN: 'WD184417',
  VYAWLIN: 'WD184420',
  TCPNFIN: 'WD184423',
  DTWICIN: 'WD184425',
  BARRIIN: 'WD184427',
  OSHWTIN: 'WD184428',
  LAKESIN: 'WD184432',
  VYACBIN: 'WD184433',
  VYOSHIN: 'WD184434',
  DUNBLIN: 'WD184435'
};

